module.exports = __webpack_public_path__ + "assets/images/Instructor.cedda7bd9a6328a6a4d303668a63234a.svg";